module.exports = __webpack_public_path__ + "static/media/th1.b4e813bd.png";